import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';

const FIVE_WHYS = `
<h2 class="basic-sub-title">
  Identifier la cause racine
</h2>
<p>
  L'outil "cinq pourquoi" est utilisé dans la résolution de problèmes pour déterminer la cause racine d'un problème.
  Identifier la cause racine d'un problème permet à l'équipe de planifier des actions correctives
  efficaces afin d'éliminer définitivement la cause racine du problème. Éliminer la cause racine devrait
  empêcher toute <strong>récurrence du problème</strong>, même si cela signifie prendre le temps de la rechercher au préalable.<br>
</p>
<br>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">D'accord, mais si un problème survient en cours de production, il faut le résoudre immédiatement. Je n'ai pas le temps de chercher la cause racine.</span>
</div>
<br>
<p>
  C'est juste, vous devez, en effet, faire tout ce que vous pouvez pour assurer la continuité de la production.
  Mais un problème est survenu et il doit être résolu de façon permanente. Les actions que vous avez menées
  pour maintenir la production ne sont probablement pas des actions de résolution, elles sont ce que nous
  appelons des "contre-mesures immédiates" ou des "actions de sécurisation" et elles ne font que corriger les symptômes du problème.<br>
  Plus tard dans la journée, ou le lendemain, l'équipe doit examiner le problème à l'aide du "cinq pourquoi".
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Prenons l'exemple du fusible :</div>
  Une machine essentielle à la production vient de s'arrêter..<br>
  <i>1. Pourquoi la machine s'est-elle arrêtée ?</i><br>Il y a eu une surcharge et le fusible a sauté.<br>
  <i>2. Pourquoi la surcharge s'est-elle produite ?</i><br>Un des roulements de refroidissement n'était pas assez lubrifié, ce qui a ralenti le refroidissement.<br>
  <i>3. Pourquoi le roulement n'était-il pas assez lubrifié ?</i><br>La pompe de lubrification était trop lente.<br>
  <i>4. Pourquoi la pompe était-elle lente ?</i><br>L'arbre de la pompe était usé et cliquetait à cause de fragments de métal.<br>
  <i>5. Pourquoi des fragments de métal heurtaient-ils l'arbre ?</i><br>La pompe a besoin d'un filtre approprié et il n'y en avait pas.<br>
</div>
<p>
  Si l'on considère cet exemple, il est assez clair que sans une étude plus approfondie et sans
  l'utilisation de l'outil "cinq pourquoi", la surcharge se reproduirait régulièrement.
  L'objectif du "cinq pourquoi" est d'identifier une cause racine à éliminer pour que le problème
  ne se reproduise plus jamais dans votre équipe ou dans une autre équipe.<br>
  Le "cinq pourquoi" de Shizen est un excellent outil pour mener à bien cette étude.
</p>
<h2 class="basic-sub-title">
  Identifier des causes réelles
</h2>
<p>
  Tout comme lorsque vous signalez des problèmes, vous devez vous assurer que les causes sont réelles.
  Et surtout, vous devez utiliser des données spécifiques pour le prouver. Pour ce faire, Shizen vous
  permet de prendre des photos ou d'ajouter d'autres types de fichiers en pièces jointes à la cause.<br>
  Dans l'exemple ci-dessus, la plupart des causes identifiées requièrent une photo.<br><br>
  Vous en apprendrez rapidement plus sur l'outil "cinq pourquoi" en le testant.
  N'hésitez pas à consulter également l'outil "Ishikawa".
  Les causes que vous ajoutez dans un outil apparaîtront dans l'autre.
</p>
`;

const FIVE_WHYS_TITLE = '5 Pourquoi';

export default {
  FIVE_WHYS,
  FIVE_WHYS_TITLE,
};
